import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35dea480"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "historyAttributetable" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "td-key" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "td-colon" }, ":", -1))
const _hoisted_5 = { class: "td-compare-value" }

import { AttributeView } from "@/attribute/convert/AttributeView";
import { ISearchDateAttributeConvert } from "@/attribute/convert/ISearchDateAttributeConvert";
import {
  ScrollContent,
  ToggleContent,
  ButtonContainer,
  ButtonItem,
} from "@/components/modules";
import {
  Ref,
  ref,
  withDefaults,
  onMounted,
  watch,
} from "vue";

interface Props {
  searchDateAttributeConvert: ISearchDateAttributeConvert;
  compareHistoryAttributeConvert: ISearchDateAttributeConvert;
  mapTimeCode: string;
  attributeTimeCode: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'history-attribute',
  props: {
    searchDateAttributeConvert: {},
    compareHistoryAttributeConvert: {},
    mapTimeCode: {},
    attributeTimeCode: {}
  },
  emits: ["exportCsv", "exportJson"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





/**
 * 表示データ
 */
const viewFormatData: Ref<AttributeView> = ref(null);

/**
 * 詳細開閉状態
 */
const isOpenToggle = ref(false);

/**
 * コンバータ変更watch
 */
watch(
  () => props.searchDateAttributeConvert,
  () => {
    refreshViewFormatData();
  }
);

/**
 * 表示内容更新
 */
const refreshViewFormatData = () => {
  viewFormatData.value = props.searchDateAttributeConvert.getViewFormatData();
};

/**
 * 詳細開閉状態更新
 */
const updateIsOpenToggle = (value: boolean) => {
  isOpenToggle.value = value;
};

/**
 * CSV出力
 */
const exportCsv = () => {
  emit(
    "exportCsv",
    props.searchDateAttributeConvert,
    props.compareHistoryAttributeConvert
  );
};

/**
 * JSON出力
 */
const exportJson = () => {
  emit("exportJson", props.searchDateAttributeConvert);
};

/**
 * 初期処理
 */
onMounted(() => {
  refreshViewFormatData();
});

__expose({ refreshViewFormatData });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ScrollContent), {
    height: 
      viewFormatData.value?.height && !isOpenToggle.value
        ? viewFormatData.value.height + 'px'
        : viewFormatData.value?.maxheight && isOpenToggle.value
        ? viewFormatData.value.maxheight + 'px'
        : '500px'
    
  }, {
    default: _withCtx(() => [
      _createElementVNode("table", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewFormatData.value?.attributeValues.length, (index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: viewFormatData.value.attributeValues[index - 1].key
          }, [
            (
            isOpenToggle.value || viewFormatData.value.attributeValues[index - 1].isSimple
          )
              ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                  _createElementVNode("td", _hoisted_3, _toDisplayString(viewFormatData.value.attributeValues[index - 1].key), 1),
                  _hoisted_4,
                  _createElementVNode("td", {
                    class: _normalizeClass([
              props.attributeTimeCode &&
              props.compareHistoryAttributeConvert &&
              !viewFormatData.value.attributeValues[index - 1].isCommon
                ? 'td-compare-value'
                : 'td-common-value',
            ])
                  }, _toDisplayString(viewFormatData.value.attributeValues[index - 1].value !== null &&
              viewFormatData.value.attributeValues[index - 1].value !== undefined &&
              String(
                viewFormatData.value.attributeValues[index - 1].value
              ).replaceAll(" ", "") !== ""
                ? String(viewFormatData.value.attributeValues[index - 1].value)
                : "-"), 3),
                  _createElementVNode("td", _hoisted_5, _toDisplayString(props.attributeTimeCode &&
              props.compareHistoryAttributeConvert &&
              !viewFormatData.value.attributeValues[index - 1].isCommon
                ? props.compareHistoryAttributeConvert?.getViewFormatData()
                    ?.attributeValues[index - 1]?.value !== null &&
                  props.compareHistoryAttributeConvert?.getViewFormatData()
                    ?.attributeValues[index - 1]?.value !== undefined &&
                  String(
                    props.compareHistoryAttributeConvert?.getViewFormatData()
                      ?.attributeValues[index - 1]?.value
                  ).replaceAll(" ", "") !== ""
                  ? String(
                      props.compareHistoryAttributeConvert?.getViewFormatData()
                        ?.attributeValues[index - 1]?.value
                    )
                  : "-"
                : ""), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      (
        (isOpenToggle.value ||
          (viewFormatData.value?.attributeValues &&
            !viewFormatData.value.attributeValues.some((ele) => {
              return !ele.isSimple;
            }))) &&
        (!viewFormatData.value?.csvOutputUnPossibility ||
          !viewFormatData.value?.jsonOutputUnPossibility)
      )
        ? (_openBlock(), _createBlock(_unref(ButtonContainer), {
            key: 0,
            align: "left"
          }, {
            default: _withCtx(() => [
              (!viewFormatData.value.csvOutputUnPossibility)
                ? (_openBlock(), _createBlock(_unref(ButtonItem), {
                    key: 0,
                    onClick: exportCsv
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("CSV出力")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!viewFormatData.value.jsonOutputUnPossibility)
                ? (_openBlock(), _createBlock(_unref(ButtonItem), {
                    key: 1,
                    onClick: exportJson
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("GeoJSON出力")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        viewFormatData.value?.attributeValues?.some((ele) => {
          return !ele.isSimple;
        })
      )
        ? (_openBlock(), _createBlock(_unref(ToggleContent), {
            key: 1,
            text: { open: '詳細表示', close: '詳細非表示' },
            onToggle: updateIsOpenToggle
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["height"]))
}
}

})